import React, { Component } from 'react'
import { Dropdown } from 'semantic-ui-react'
import { translate } from 'react-i18next'

import { connect } from 'react-redux'
import { dispatchFilter, setPaginationProfileSelectedPage, setPaginationSelectedPage } from '../../store/actions/FilterActions'
import { projectDataFetchData } from '../../store/actions/ProjectFetchActions'
import { profileDataFetchData } from '../../store/actions/ProfileFetchActions'
import { membersTeamDataFetchData } from '../../store/actions/UserTeamFetchActions'
import { userFetchDataSuccess } from '../../store/actions/UserActions'

class TeamSwitcher extends Component {
    onChangeTeamValue(e, data) {
        this.updateRole(data.value)
        this.props.changeFilter(null, data.value)
        this.props.fetchProfile(null, 15, 1)
        // this.props.memberTeam()
    }

    menuChangeTeam(data, e) {
        this.updateRole(data)
        this.props.changeFilter(null, data)
        this.props.changePageProj(1)
        this.props.changePageProf(1)
        this.props.fetchProject(null, 15, 1)
        this.props.fetchProfile(null, 15, 1)
        // this.props.memberTeam()
    }

    // Update internal user role/permission at the change of the team
    updateRole(team_id) {
        const fullData = this.props.team.filter(item => item.team_id === team_id)[0]
        let localUser = Object.assign({}, this.props.user)
        localUser.role_id = fullData.role_id
        localUser.role = {id: fullData.role_id, role_desc: fullData.role.role_desc}
        localUser.user_permissions = JSON.parse(fullData.user_permissions)
        this.props.updateUser(localUser)
    }

    // MAIN RENDER
    render() {
        const { t } = this.props

        let dropdownTeamOptions = []
        this.props.team.forEach((item) => {
            dropdownTeamOptions.push({
              text: item.team_name,
              value: item.team_id,
              disabled: item.status === 0 || item.status_team === 0 ? true : false
            });
        })

        let indexTeam = this.props.team.findIndex(x => x.team_id === this.props.teamID)
        if (this.props.type === 'menu') {
            let menuOptions = dropdownTeamOptions
            menuOptions = menuOptions.map((item, index) => {
                return (
                    <Dropdown.Item
                        onClick={this.menuChangeTeam.bind(this, item.value)}
                        key={index}
                        disabled={item.disabled}
                    >
                        {item.text}
                    </Dropdown.Item>
                )
            })
            return (
                // <Dropdown item text={this.props.team[indexTeam] ? this.props.team[indexTeam].team_name : ''}>
                <Dropdown item text={this.props.team[indexTeam].team_name}>
                    <Dropdown.Menu>
                        {menuOptions}
                    </Dropdown.Menu>
                </Dropdown>
            )
        }

        return (
            <Dropdown
                style={this.props.style}
                selection
                placeholder={t("TMSEL_DROP_PLACEHOLDER")}
                options={dropdownTeamOptions}
                defaultValue={this.props.defaultValue}
                onChange={this.onChangeTeamValue.bind(this)}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        team: state.userTeamData,
        teamID: state.filterValue,
        user: state.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeFilter: (mode, value) => dispatch(dispatchFilter(mode, value)),
        fetchProject: (query, limit, page) => dispatch(projectDataFetchData(query, limit, page)),
        fetchProfile: (query, limit, page) => dispatch(profileDataFetchData(query, limit, page)),
        changePageProj: value => dispatch(setPaginationSelectedPage(value)),
        changePageProf: value => dispatch(setPaginationProfileSelectedPage(value)),
        memberTeam: (query) => dispatch(membersTeamDataFetchData(query)),
        updateUser: (user) => dispatch(userFetchDataSuccess(user)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('translations')(TeamSwitcher))



// WEBPACK FOOTER //
// ./src/containers/switcher/TeamSwitcher.js